<template>
  <div class="d-inline mt-1">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          class="ml-2 mr-1"
          v-bind="attrs"
          v-on="on"
          color="primaryDark"
          @click="chatForMeetingDialog"
        >
          <v-icon size="14" class="mr-1">mdi-chat</v-icon>
          {{ $t("chat.lblChat") }}
        </a-btn>
      </template>
      <span>{{ $t("chat.tiplblChat") }}</span>
    </v-tooltip>
    <a-dialog v-model="isOpen" width="60vw" persistent scrollable>
      <v-card>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1">
            <span> {{ $t("chat.lblChatForMeeting") }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="isOpen = false" />
          </v-toolbar>
        </v-banner>
        <v-card-text style="padding: 10px 20px 20px 20px">
          <v-card class="d-flex justify-end mb-6" flat tile>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  class="mx-1 my-1"
                  color="primaryDark"
                  v-bind="attrs"
                  v-on="on"
                  @click="createChat"
                >
                  <v-icon size="16" class="mr-1">mdi-plus</v-icon>
                  {{ $t("chat.lblCreateChat") }}
                </a-btn>
              </template>
              <span>{{ $t("chat.lblCreateChat") }}</span>
            </v-tooltip>
          </v-card>

          <a-data-table
            :headers="topicHeads"
            :items="chatItems"
            class="elevation-1"
            item-key="id"
            :no-data-text="$t('noData')"
            :loading-text="$t('LoaderText')"
            mobile-breakpoint="0"
            height="50vh"
            hide-default-footer
            disable-pagination
            dense
            fixed-header
          >
            <template v-slot:[`header.chat`]="{ header }">
              {{ header.text }}#
            </template>
            <template v-slot:[`header.action`]="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-on="on" v-bind="attrs"> {{ header.text }} </span>
                </template>
                <span v-html="$t('agenda.tipforAction')"></span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.index`]="{ item }">
              <a
                href="javascript:void(0)"
                v-if="isParticipant(item.participants)"
                @click="chatTimeLineBoxDialog(item)"
                >{{ item.index }}</a
              >
              <span v-else>{{ item.index }}</span>
            </template>

            <template v-slot:[`item.title`]="{ item }">
              <div
                style="
                  max-width: 150px;
                  word-wrap: break-word;
                  width: fit-content;
                  word-break: break-all;
                "
              >
                <v-tooltip bottom :disabled="!isEllipsis(item.title, 50)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" style="display: inline-block">
                      <a
                        href="javascript:void(0)"
                        v-if="isParticipant(item.participants) && item.title"
                        @click="chatTimeLineBoxDialog(item)"
                      >
                        {{ item.title ? ellipsis(item.title, 50) : "-" }}
                      </a>
                      <span v-else>
                        {{ item.title ? ellipsis(item.title, 50) : "-" }}</span
                      >
                    </div>
                  </template>
                  <span v-text="item.title"></span>
                </v-tooltip>
                <!-- <a href="javascript:void(0)" v-if="isParticipant(item.participants) && item.title" @click="chatTimeLineBoxDialog(item)">{{ item.title }}</a>
                <span v-else> {{ item.title ? item.title : "-" }}</span> -->
              </div>
            </template>

            <template v-slot:[`item.participants`]="{ item }">
              <div v-if="item.participants && item.participants.length > 0">
                <v-list-item
                  v-for="participant in item.participants"
                  :key="`p-item-${participant.id}`"
                  style="max-height: 28px; min-height: auto"
                  class="pl-0"
                >
                  <v-list-item-avatar size="20" class="my-0 mr-2">
                    <v-img
                      v-if="participant.profilePhoto"
                      contain
                      :src="participant.profilePhoto"
                    ></v-img>
                    <v-img
                      v-else
                      contain
                      src="@/assets/images/NoPhotoIcon.png"
                    ></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title style="text-align: left">
                      <span :class="{'grey--text': !participant.is_authorized}">{{ `${participant.firstName} ${participant.lastName}` }}</span>
                      <v-chip
                        class="ml-2"
                        color="neutralGray"
                        outlined
                        small
                        v-if="participant.id == item.created_by"
                      >
                        {{ $t("lblOwner") }}
                      </v-chip>
                      <v-chip
                        class="ml-2"
                        color="neutralGray"
                        outlined
                        small
                        v-if="!participant.is_authorized"
                      >
                      {{ $t("lblAccessRevoked") }}
                      </v-chip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>

            <template v-slot:item.created_date="{ item }">
              {{ formatDate(new Date(item.created_date), displayDateFormat) }}
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    @click="changeParticipants(item)"
                    :disabled="item.created_by !== $auth.user.user_id"
                  >
                    <v-icon small>mdi-account-multiple</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("chat.lblUpdateParticipant") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    @click="confirmDeleteMeetingChat(item)"
                    :disabled="
                      !(
                        deleteMeetingChatPermission ||
                        item.created_by == $auth.user.user_id
                      )
                    "
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("btnDelete") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    @click.stop="alertNotification(item)"
                  >
                    <v-icon small>mdi-email</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("agenda.lblSendNotification") }}</span>
              </v-tooltip>
            </template>
          </a-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <confirm-dialog ref="confirmDelete" />
      </v-card>
    </a-dialog>
    <ChatCreation
      v-if="createChatDialog"
      v-model="createChatDialog"
      :meetingId="selectedMeeting.id"
      :meetingTypeId="selectedMeeting.meetingTypeId"
      :attendeesList="attendeesList"
      :chatData="chatData"
      @back="onBack"
      @chatCreated="chatCreated"
    ></ChatCreation>
    <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
    <email-alert-notification
      v-if="dialogAlertNotification"
      v-model="dialogAlertNotification"
      :emailTemplate="emailTemplate"
      :defaulter="defaulter"
      :suggestedList="suggestedAttendees"
      @send="onEmailSend"
      type="remind"
      :heading="alertHeading"
    ></email-alert-notification>
    <chat-timeline-box
      v-if="openChatBox && isThisInChatBox"
      :chatId="chatId"
      v-model="openChatBox"
      :meetingObject="selectedMeeting"
    ></chat-timeline-box>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ConfirmDialog from "../../ConfirmDialog.vue";
import ChatCreation from "./ChatCreation.vue";
import ChatTimelineBox from "./ChatTimelineBox.vue";
import SignalRMixin from "../../../mixin/SignalRMixin";
import MessageSheet from "@/components/MessageSheet.vue";
import { formatDate } from "@/utils/util";
import EmailAlertNotification from "@/components/EmailAlertNotification.vue";
export default {
  name: "ChatForMeeting",
  mixins: [SignalRMixin],
  components: {
    ChatCreation,
    ChatTimelineBox,
    ConfirmDialog,
    MessageSheet,
    EmailAlertNotification,
  },
  props: {
    attendeesList: Array,
    selectedMeeting: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isOpen: false,
      createChatDialog: false,
      openChatBox: false,
      chatData: null,
      chatBoxItem: null,
      chatId: null,
      displayMessage: false,
      message: "",
      messageType: "",
      dialogAlertNotification: false,
      alertHeading: this.$t("agenda.hNotification"),
      alertTemplate: {},
      defaulter: [],
      suggestedAttendees: [],
      stringLength: 25,
    };
  },
  computed: {
    ...mapState({
      agendaMeetingChatLists: (state) => state.agenda.agendaMeetingChatLists,
      userList: (state) => state.people.userList,
      deletedUserList: (state) => state.meeting.deletedUserList,
    }),
    ...mapGetters({
      getTemplateByTemplateTypeId: "tenant/getTemplateByTemplateTypeId",
    }),
    topicHeads() {
      return [
        {
          text: `${this.$t("chat.lblChat")} #`,
          align: "start",
          value: "index",
          sortable: false,
          groupable: false,
          width: "10%",
          class: "header-text header label-s",
        },
        {
          text: this.$t("title"),
          align: "start",
          value: "title",
          sortable: false,
          groupable: false,
          width: "10%",
          class: "header-text header label-s",
        },
        {
          text: this.$t("chat.lblParticipant"),
          align: "center",
          value: "participants",
          width: "10%",
          groupable: false,
          sortable: false,
          class: "header-text header label-s",
        },
        {
          text: this.$t("chat.lblCreationDate"),
          align: "center",
          value: "created_date",
          width: "10%",
          groupable: false,
          sortable: false,
          class: "header-text header label-s",
        },
        {
          align: "center",
          text: this.$t("agenda.hAction"),
          value: "action",
          width: "12%",
          groupable: false,
          sortable: false,
          class: "header-text header label-s",
        },
      ];
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      return tenant ? tenant.name : "";
    },
    chatItems() {
      let localUserList = [...this.userList];
      localUserList = localUserList.concat(this.deletedUserList);
      return this.agendaMeetingChatLists.map((obj, index) => {
        const participants =
          obj.participants?.map((participant) => {
            const userData = localUserList.find(
              (user) => user.id === participant.id
            );
            return {
              ...participant,
              firstName: userData.firstName || null,
              lastName: userData.lastName || null,
              profilePhoto: userData.profilePhoto || null,
            };
          }) || [];

        return {
          ...obj,
          index: index + 1,
          participants,
        };
      });
    },
    deleteMeetingChatPermission() {
      if (this.selectedMeeting) {
        return this.$security.checkMeetingTypeAccess(
          this.selectedMeeting.meetingTypeId,
          "DeleteMeetingChat"
        );
      }
      return false;
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    displayDateFormat() {
      return this.selectedLang !== "ja" ? "dd-MM-yyyy h:mm aaa" : "yyyy-MM-dd HH:mm";
    },
    emailTemplate: {
      get() {
        return this.alertTemplate;
      },
      set(val) {
        this.alertTemplate = val;
      },
    },
    isThisInChatBox() {
      if (!this.chatBoxItem) {
        return true;
      }
      return this.chatBoxItem.participants.some(
        (obj) => obj.id === this.$auth.user.user_id
      );
    },
    getChatTemplate() {
      return this.getTemplateByTemplateTypeId("Chats",  this.selectedLang);
    },
    
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd/MM/yyyy" : "yyyy/MM/dd";
    },
  },
  async mounted() {
    const target = "meeting_chat_create_" + this.selectedTenant;
    const updateTarget = "meeting_chat_update_" + this.selectedTenant;
    const deleteTarget = "meeting_chat_delete_" + this.selectedTenant;
    await this.signalRInit(target);
    await this.signalRInit(updateTarget);
    await this.deleteSignalRInit(deleteTarget);
    const targetAdminPermission = "admin_" + this.selectedTenant;
    await this.signalRAdminPermission(targetAdminPermission);
  },
  methods: {
    formatDate,
    ...mapActions({
      listMeetingChatsAndComments: "agenda/listMeetingChatsAndComments",
      chatParticipants: "agenda/chatParticipants",
      deleteMeetingChat: "agenda/deleteMeetingChat",
      listMeetingChatComments: "agenda/listMeetingChatComments",
      setChatMessages: "agenda/setChatMessages",
      getDeletedUsersList: "meeting/getDeletedUsersListTemp",
    }),
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    createChat() {
      this.chatData = null;
      this.createChatDialog = true;
    },
    changeParticipants(item) {
      this.chatData = item;
      this.createChatDialog = true;
    },
    async chatForMeetingDialog() {
      await this.listMeetingChatsAndComments(this.selectedMeeting.id);
      await this.chatParticipants(this.selectedMeeting.meetingTypeId);
      this.isOpen = true;
    },
    async chatCreated(res) {
      try {
        this.chatId = res.data.id;
        if (res.status) {
          await this.listMeetingChatsAndComments(this.selectedMeeting.id);
          this.setChatMessages(null);
          const message = !res.is_updated
            ? this.$t("chat.msgChatCreateSuccess")
            : this.$t("chat.msgChatUpdateSuccess");
          this.showMessageSheet(message, "success");
        }
        this.createChatDialog = false;
        if (!res.is_updated) {
          this.openChatBox = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    isParticipant(participants) {
      return participants.some((obj) => obj.id === this.$auth.user.user_id);
    },
    async chatTimeLineBoxDialog(item) {
      if (!this.isParticipant(item.participants)) return false;
      try {
        this.chatId = item.id;
        this.chatBoxItem = item;
        await this.listMeetingChatComments(item.id);
        this.openChatBox = true;
      } catch (error) {
        this.openChatBox = false;
      }
    },

    async confirmDeleteMeetingChat(item) {
      try {
        if (
          await this.$refs.confirmDelete.open(
            this.$t("agenda.hDeleteMessage"),
            this.$t("agenda.lblDeleteMessage")
          )
        ) {
          const response = await this.deleteMeetingChat(item.id);
          if (response.status) {
            const chatindex = this.agendaMeetingChatLists.findIndex(
              (chat) => chat.id == item.id
            );
            chatindex !== -1 &&
              this.agendaMeetingChatLists.splice(chatindex, 1);
            this.showMessageSheet(
              this.$t("chat.msgChatDeleteSuccess"),
              "success"
            );
          } else {
            this.showMessageSheet(this.$t("chat.msgChatFaild"), "error");
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    onBack() {},
    async signalRInit(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          if (res.data) {
            this.chatBoxItem = res.data;
          }
          await this.listMeetingChatsAndComments(this.selectedMeeting.id);
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteSignalRInit(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          await this.listMeetingChatsAndComments(this.selectedMeeting.id);
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async signalRAdminPermission(target) {
      try {
        this.signalConnection.on(target, async (message) => {
          await this.listMeetingChatsAndComments(this.selectedMeeting.id);
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        console.log(error, "api error");
      }
  },
    alertNotification(item) {
      const chatindex = this.agendaMeetingChatLists.findIndex(
        (chat) => chat.id == item.id
      );
      const title =
        item && item.title
          ? `#${chatindex + 1} - ${item.title}`
          : `#${chatindex + 1}`;

      const participants = item.participants.map((obj) => {
        const userData = this.userList.find((user) => user.id === obj.id) || {};
        return {
          ...obj,
          contactEmailIds: userData.contactEmailIds || [],
        };
      });
      const placeHolderVariables = {
        "{{%date%}}": formatDate(new Date(item.created_date), this.dateFormat),
        "{{%tenant%}}": this.tenantName,
        "{{%meeting_name%}}": this.selectedMeeting.meetingName,
        "{{%chat_title%}}": title,
      };

      this.alertTemplate = {
        subject: this.getChatTemplate.subject.replace(
          /{{%[^}]+%}}/g,
          (match) => placeHolderVariables[match] || ""
        ),
        message: this.getChatTemplate.body.replace(
          /{{%[^}]+%}}/g,
          (match) => placeHolderVariables[match] || ""
        ),
        mailType: "chat-notification",
        dynamicVariables: {
          targetId: this.selectedMeeting.id,
          meetingTypeId: this.selectedMeeting.meetingTypeId,
          targetTitle: this.selectedMeeting.meetingName,
          targetLinkLabel: this.$t("agenda.meetingTargetLinkLabel"),
        },
      };
      this.suggestedAttendees = participants;
      this.defaulter = participants;
      this.dialogAlertNotification = true;
    },
    onEmailSend(isSucess) {
      if (isSucess) {
        this.showMessageSheet(
          this.$t("agenda.SendEmailNotification"),
          "success"
        );
      } else {
        this.showMessageSheet(
          this.$t("agenda.FaildEmailNotification"),
          "error"
        );
      }
    },
    isEllipsis(string, length) {
      const strlen = length != undefined ? length : this.stringLength;
      return String(string).length > strlen;
    },
    ellipsis(string, length) {
      const strlen = length != undefined ? length : this.stringLength;
      return this.isEllipsis(string, length)
        ? string.substring(0, strlen) + "..."
        : string;
    },
  },
};
</script>
